// extracted by mini-css-extract-plugin
export var banner = "gift_banner__RfHs-";
export var container = "gift_container__ZTZqn";
export var giftAmount = "gift_giftAmount__qHvPP";
export var payment = "gift_payment__J2G83";
export var section = "gift_section__SPRhg";
export var sectionBodyBottomBorder = "gift_sectionBodyBottomBorder__HECMD";
export var sectionTitle = "gift_sectionTitle__N0kwW";
export var sectionTitleImage = "gift_sectionTitleImage__yS+W1";
export var sectionTitleWithImage = "gift_sectionTitleWithImage__V4ljL";
export var sendIt = "gift_sendIt__si5l6";
export var sender = "gift_sender__rVjOY";
export var subContainer = "gift_subContainer__3T+C7";
export var title = "gift_title__R3gHH";